import React, { useEffect, useState } from 'react';

function MessageBubble({ message, isUser }) {
  const [displayedMessage, setDisplayedMessage] = useState(message || '');

  useEffect(() => {
    if (!message) {
      setDisplayedMessage('');
      // console.log('Message is undefined or empty, set to empty string');
    } else {
      setDisplayedMessage(message);
      // console.log('Rendering message in MessageBubble:', message);
    }
  }, [message]);

  return (
    <div
      className={`p-2 rounded-lg max-w-70vw ${
        isUser ? 'bg-blue-500 text-white' : 'bg-gray-300 text-gray-800'
      } text-left`}
    >
      {displayedMessage}
    </div>
  );
}

export default MessageBubble;